import { tagsData, addNewTag, removeTag, editTag, assignTag, unassignTag } from './types';

export const requestClientTagsData = (entityId, promise) => ({
  type: tagsData.request,
  entityId,
  promise,
});

export const requestClientTagsDataSuccess = (response) => ({
  type: tagsData.success,
  response,
});

export const requestClientTagsDataFailure = (error) => ({
  type: tagsData.failure,
  error,
});

export const requestDeleteClientTag = (tagId) => ({
  type: removeTag.request,
  tagId,
});

export const requestDeleteClientTagSuccess = (response) => ({
  type: removeTag.success,
  response,
});

export const requestDeleteClientTagFailure = (response) => ({
  type: removeTag.failure,
  response,
});

export const requestAddClientTag = (payload, promise) => ({
  type: addNewTag.request,
  payload,
  promise,
});

export const requestAddClientTagSuccess = (response) => ({
  type: addNewTag.success,
  response,
});

export const requestAddClientTagFailure = (response) => ({
  type: addNewTag.failure,
  response,
});

export const requestEditClientTag = (tagId, payload) => ({
  type: editTag.request,
  tagId,
  payload,
});

export const requestEditClientTagSuccess = (response) => ({
  type: editTag.success,
  response,
});

export const requestEditClientTagFailure = (response) => ({
  type: editTag.failure,
  response,
});

export const requestAssignTag = (entityId, payload) => ({
  type: assignTag.request,
  entityId,
  payload,
});

export const requestAssignTagSuccess = (response) => ({
  type: assignTag.success,
  response,
});

export const requestAssignTagFailure = (response) => ({
  type: assignTag.failure,
  response,
});

export const requestUnassignTag = (entityId, tagId) => ({
  type: unassignTag.request,
  entityId,
  tagId,
});

export const requestUnassignTagSuccess = (response) => ({
  type: unassignTag.success,
  response,
});

export const requestUnassignTagFailure = (response) => ({
  type: unassignTag.failure,
  response,
});
